module.exports = __webpack_public_path__ + "img/shebei5Pro.90904cb3.png";